import AsyncComponent from '../../component/asynccomponent/AsyncComponent'
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const customer = AsyncComponent(() =>
  import('../../../pages/customer/CustomerIndex')
)

const customers = AsyncComponent(() =>
  import('../../../pages/customer/CustomersGrid')
)

export default [
  {
    path: '/company/:companyId/customer',
    component: customer,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/company/:companyId/customer/:id',
    component: customer,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/customers/:id',
    component: customers,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  }
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/CustomerRoutes.js